<template>
  <div class="tw-inline-block">
    <VDropdown
      @apply-show="isFocusLoopActive = true"
      @apply-hide="isFocusLoopActive = false"
      placement="bottom-end"
    >
      <IconButton color="outline-secondary">
        <PlusIcon />
      </IconButton>
      <template #popper>
        <div class="tw-max-h-64 tw-w-52 tw-overflow-y-auto tw-p-2">
          <FocusLoop
            :is-active="isFocusLoopActive"
            :auto-focus="false"
            is-arrows-navigation-active
          >
            <ul>
              <li v-for="action in actions" :key="action.value">
                <a
                  :href="action.formLink"
                  target="_blank"
                  class="tw-flex tw-items-center tw-rounded-md tw-px-3 tw-py-4 tw-text-sm tw-font-semibold tw-text-primary-500 hover:tw-bg-primary-50 hover:tw-text-primary-600 focus:tw-outline-none focus-visible:tw-ring focus-visible:tw-ring-primary-50"
                >
                  <component
                    class="tw-mr-4 tw-w-6 tw-text-primary-500"
                    :is="action.icon"
                  />
                  {{ action.label }}
                </a>
              </li>
            </ul>
          </FocusLoop>
        </div>
      </template>
    </VDropdown>
  </div>
</template>

<script setup>
import IconButton from '@/shared/components/IconButton.vue'
import PlusIcon from '@/assets/images/icons/plus.svg'
import FocusLoop from '@/shared/components/FocusLoop.vue'
import { ref } from 'vue'

defineProps({
  actions: {
    type: Array,
    default: () => [],
  },
})

const isFocusLoopActive = ref(false)
</script>
